import React from 'react';
import { Link } from "react-router-dom";

import config from '../config.json'

import styled from 'styled-components';
import { getColoresGlobales } from '../utils/domUtils';

const coloresGlobales = getColoresGlobales()

const Container = styled.div`
  background-color: ${coloresGlobales.base};
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 20px;
  padding-right: 20px;
  color: white;
  z-index: 9999;
`;

const Section = styled.div`
  margin-bottom: 25px;
`;

const SectionTitle = styled.h2`
  display: flex;
  align-items: center; // Alinea los elementos verticalmente en el centro
  font-size: 1.2em;
  color: #fff;
  border-bottom: 1px solid #fff;
  padding-bottom: 7px;
`;

const SectionImage = styled.img`
  width: 30px;
  height: 30px;
  margin-right: 10px;
  filter: invert(1);
`;

const LinkList = styled.ul`
  list-style: none;
  padding: 0;
`;

const ListItem = styled.li`
  display: flex;
  align-items: center;
  margin: 10px 0;
`;

const StyledLink = styled(Link)`
  color: white;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
    color: #ccc;
  }
`;

const StyledAnchor = styled.a`
  display: flex;
  color: white;
  text-decoration: none;
  &:hover {
    color: #ccc;
    cursor: pointer;
  }
`;

function MenuInicio({ seccionesNavegar, urlBaseIconos, extensionIconos }) {
    const handleClick = (seccion, visor) => {
      // window.open(`/${config.urlBase}/${seccion.codigo}/${visor.codigoVisor}/${config.tipoRutaNavegarGeneral}/${config.tipoNavegacionSinIni}`, '_blank', 'noopener,noreferrer');
      window.open(`/${config.urlBase}/${seccion.codigo}/${visor.codigoVisor}`, '_blank', 'noopener,noreferrer');
    };
    const urlBaseStd = urlBaseIconos.endsWith("/") ? urlBaseIconos : `${urlBaseIconos}/`; //Agrega slash final si no lo tiene
    return (
      <React.Fragment>
      <Container>
        {seccionesNavegar.map((seccionNavegar) => (
          seccionNavegar.esDeVisorInicio ? null :
          <Section key={seccionNavegar.codigo}>
              <SectionTitle>
              <SectionImage src={`${urlBaseStd}${seccionNavegar.codigo}.${extensionIconos}`} alt={seccionNavegar.nombre} />
              {seccionNavegar.nombre}</SectionTitle>
            <LinkList>
              {seccionNavegar.visores.map((visor) => (
                visor.esInicio ? null :
                <ListItem key={visor.codigoVisor}>
                  <StyledAnchor title='Abrir en una nueva pestaña' onClick={() => handleClick(seccionNavegar, visor)}>
                    <div className='esri-icon-launch-link-external'></div>
                  </StyledAnchor>
                  <span style={{paddingLeft: "5px", paddingRight: "5px"}}/>
                  <StyledLink to={`/${seccionNavegar.codigo}/${visor.codigoVisor}/${config.tipoRutaNavegarGeneral}`} title='Ir'>
                    {visor.nombre}
                  </StyledLink>
                </ListItem>
              ))}
            </LinkList>
          </Section>
        ))}
      </Container>
      <div style={{padding: "10px", textAlign: "left", fontSize: "medium", lineHeight: "1.5"}}>
        Oprime en el nombre del visor geográfico para abrirlo en esta misma pestaña y poder navegar entre visores con un menú incluido allí. Oprime el botón <span className='esri-icon-launch-link-external'></span> para abrir el visor asociado en una nueva pestaña.
      </div>
      </React.Fragment>
    );
}

export default MenuInicio;

